module.exports = __webpack_public_path__ + "static/media/swingHardware2.20024138.png";